const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY h:mm A';

export {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_TIME_FORMAT,
};
